<template>

  <div class="elevation-4">
    <v-toolbar flat="flat">
      <v-toolbar-title>Informations</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" :persistent="true" max-width="700px">
        <v-icon medium="medium" slot="activator">mdi-pencil</v-icon>
        <v-card>
          <v-card-title class="headline">Edit informations</v-card-title>
          <v-card-text>
            <v-container fluid="fluid" grid-list-xl="grid-list-xl">
              <v-flex>
                <v-text-field v-model="editedInfos.name" label="Name" placeholder="Name"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="editedInfos.alias" label="Alias" placeholder="Alias"></v-text-field>
              </v-flex>
              <v-flex>
                <div class="error-message">{{ errorMessage }}</div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
            <v-btn color="primary" flat="flat" @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div class="content" v-if="federation !== undefined">
      <div>ID: {{ federation.id }}</div>
      <div>Name: {{ federation.name }}</div>
      <div>Alias: {{ federation.alias }}</div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'FederationInfos',
  props: ['federation', 'loading'],
  data: () => ({
    editedInfos: {
      name: null,
      alias: null
    },
    dialog: null,
    errorMessage: ''
  }),
  methods: {
    close () {
      this.dialog = false
      this.editedInfos = {
        name: null,
        alias: null
      }
      this.errorMessage = ''
    },
    save () {
      if (!this.editedInfos.name) {
        this.errorMessage = 'You must enter a name'
        return
      }

      this.$store.dispatch('patchFederation', {
        id: this.federation.id,
        patch: {
          name: this.editedInfos.name,
          alias: this.editedInfos.alias
        }
      })
        .then(() => {
          this.close()
        })
    }
  },
  watch: {
    'dialog' () {
      if (this.dialog) {
        this.editedInfos = {
          name: this.federation.name,
          alias: this.federation.alias
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.content {
  padding: 25px;
}

</style>



// WEBPACK FOOTER //
// src/pages/federation/FederationInfos.vue